import type { Fetcher } from "react-query-kit";
import { createInfiniteQuery, createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../types";
import { getApi } from "../apiPath";
import { axiosClient } from "../clients";

import type { IUsers } from "./routeType";

import { infiniteHelper } from "@/utils";

const { key, getPath } = getApi("users.getAll");

type IExtractedRouteType = IUsers["userCollectionRetrieve"];

export type IGetAllUsers = IPickCollectionQuery<IExtractedRouteType>;

const getAllUser: Fetcher<
  IGetAllUsers["response"],
  IGetAllUsers["variables"],
  number
> = (params, { pageParam }) => {
  return axiosClient.get(getPath(), {
    params: { ...params, page: pageParam ?? params?.page },
  });
};

export const useGetAllUser = createQuery({
  queryKey: [key],
  fetcher: getAllUser,
});

export const useGetAllUsersInfinite = createInfiniteQuery({
  queryKey: [`infinite.${key}`],
  fetcher: getAllUser,
  ...infiniteHelper,
});
